import BasicClaimView from "./BasicClaimView";

export default BasicClaimView;
